'use client'

import { calculateDistance } from '@/hooks'
import { useStoreGeo } from '@/store'
import { memo } from 'react'

export type CoordinatesProps = {
  latitude: number
  longitude: number
}

const Distance = ({
  coordinates,
  className
}: {
  className?: string
  coordinates?: CoordinatesProps
}) => {
  const currentLocation = useStoreGeo.use.location()

  if (!coordinates || !currentLocation.latitude || !currentLocation.longitude) {
    return null
  }

  const distance = calculateDistance(currentLocation, coordinates).toFixed(1)

  return <div className={className}>{`${distance} km`}</div>
}

Distance.displayName = 'Distance'

export default memo(Distance)
